import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import React, {
  forwardRef,
} from 'react';
import {
  Eventcalendar,
  MbscEventcalendarOptions,
  Page,
  setOptions,
} from '@mobiscroll/react';
import clsx from 'clsx';

setOptions({
  theme: 'ios',
  themeVariant: 'light',
});

type Props = MbscEventcalendarOptions & {
  classes?: Record<'page', string>;
};

const EventCalendar = forwardRef<Eventcalendar, Props>(({ classes, ...props }, ref) => (
  <Page
    className={clsx(
      'calendar-view',
      classes?.page,
    )}
  >
    <Eventcalendar
      {...props}
      ref={ref}
    />
  </Page>
));

export default EventCalendar;
